import React, { useState, useEffect, useRef } from "react";
import "handsontable/dist/handsontable.full.min.css";
import { HotTable } from "@handsontable/react";
import { registerAllModules } from "handsontable/registry";
import axios from "axios";
import { TableCell, TableContainer, TableRow } from "@material-ui/core";

registerAllModules();

function ExpenseDetailTable({ formState, setGLAccountTotal }) {
  const hotRef = useRef(null);
  const [columns, setColumns] = useState([]);

  const columnHeaders = [
    "Expense Date",
    "Description",
    "Amount",
    "GL Account",
    "Cost Center",
    "CC Owner Code",
    "CC Owner",
    "Fixed Asset",
    "TType",
    "Profit Center",
  ];

  useEffect(() => {
    const data = [
      {
        data: "expenseDate",
        width: 170,
        type: "date",
        dateFormat: "YYYY-MM-DD",
      },
      {
        data: "description",
        width: 200,
        type: "text",
      },
      {
        data: "amount",
        width: 170,
        type: "numeric",
        numericFormat: {
          pattern: "0,0.00",
          culture: "en-US", // this is the default culture, set up for USD
        },
      },
      {
        data: "GLAccount",
        type: "autocomplete",
        source: function (query, proces) {
          // var _data = { 'query': query };
          let _gl = "";
          if (query != null && query != "" && query.split("-").length == 1) {
            _gl = query.split("-")[0];
          }
          axios({
            method: "get", //you can set what request you want to be
            url: `${
              process.env.REACT_APP_API_URL
            }/api/Invoices/GetChargeAccount_v1/${_gl ? _gl : -1}`,
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user_token")}`,
              "Content-Type": "application/json",
            },
          })
            .then((response) => {
              proces(
                response.data.map(function (m) {
                  return m.GLAccount + " - " + m.ShortText;
                })
              );
            })
            .catch(function (err) {
              console.log(err);
            });
        },
        strict: false,
        width: 300,
      },
      {
        data: "costCenter1",
        type: "autocomplete",
        source: function (query, proces) {
          var data = { query: query };
          let _ca = "";
          if (query != null && query != "" && query.split("-").length == 1) {
            _ca = query.split("-")[0];
          }
          axios({
            method: "get", //you can set what request you want to be
            url: `${
              process.env.REACT_APP_API_URL
            }/api/Invoices/GetCostCenters_v1/${_ca ? _ca : "-1"}`,
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user_token")}`,
              "Content-Type": "application/json",
            },
          })
            .then((response) => {
              proces(
                response.data.map(function (m) {
                  return m.CostCenterCode + " - " + m.Name;
                })
              );
            })
            .catch(function (err) {
              console.log(err);
            });
        },
        strict: false,
        width: 180,
      },
      {
        data: "costCenterOwner",
        width: 1,
        type: "text",
        readOnly: true,
      },
      {
        data: "costCenterOwnerName",
        width: 200,
        type: "text",
        readOnly: true,
      },
      {
        data: "fixedAsset",
        width: 110,
        type: "text",
      },
      {
        data: "tType",
        width: 110,
        type: "text",
      },
      {
        data: "profitCenter",
        width: 110,
        type: "text",
      },
    ];

    setColumns(data);
  }, [formState?.Expense_Accounts_list]);
  const calculateTotalAmount = () => {
    const totalAmount = formState?.Expense_Accounts_list?.reduce(
      (accumulator, currentValue) => {
        return accumulator + Number(Number(currentValue?.amount)?.toFixed(2));
      },
      0
    );

    return totalAmount;
  };
  const totalAmount = calculateTotalAmount();
  return (
    <>
      <HotTable
        data={formState?.Expense_Accounts_list || []}
        colHeaders={columnHeaders}
        columns={columns}
        manualRowResize={true}
        manualColumnResize={true}
        rowHeaders={true}
        height="200"
        rowHeaderWidth={25}
        contextMenu={true}
        filters={true}
        width="100%"
        hiddenColumns={{
          indicators: true,
          columns: [5],
        }}
        readOnly={true}
        dropdownMenu={true}
        ref={hotRef}
        licenseKey="non-commercial-and-evaluation" // for non-commercial use
      />
      <TableContainer>
        {formState?.Expense_Accounts_list?.length > 0 && (
          <TableRow>
            <TableCell colSpan={2} align="center">
              <b>Invoice Amount</b>
            </TableCell>
            <TableCell colSpan={3}>{totalAmount}</TableCell>
            {/* <TableCell colSpan={3}>{amountTotal}</TableCell> */}
          </TableRow>
        )}
      </TableContainer>
    </>
  );
}

export default ExpenseDetailTable;
